import { InfoWindow, Marker } from '@react-google-maps/api';
import React, { useEffect, useRef, useState, useContext } from 'react'
import { getLocalisedDate, getLocalisedTime } from '../../../Library/datetime';
import "./style.css";
import { DEVICE_HWTYPS, VEHICLE_TYPES, VEHICLE_ICON_URLS, VEHICLE_TYPE_BIKE } from '../../../Library/constants';
import { AuthContext } from '../../../Library/contexts';
import { FridgeIconUrl } from '../../../Assets/images/svgs';

const CustomMarker = ({ vehicle, vehicleInfo = {}, onInfoWindowClose, clusterer }) => {
    const { profile } = useContext(AuthContext);
    const markerRefs = useRef({});
    const [ showInfoBox, setShowInfoBox ] = useState(false);
    const targetVehicle = vehicleInfo;

    const isFridgeUser = profile && profile.mob === 8080808045;

    useEffect(() => {
      const timeout = setTimeout(() => {
        if (isFridgeUser) return;
        const parent = document.querySelector(`div[style*="z-index: ${vehicle.vid}"]`);
        const marker = document.querySelector(`div[style*="z-index: ${vehicle.vid}"] img`);
        if (marker) {
          const currentRotation = parseFloat(marker.style.transform.replace(/rotate\((.*)deg\)/, '$1')) || 0;
          const newRotation = getShortestRotation(currentRotation, vehicle.direction);

          marker.style.transition = "cubic-bezier(0.19, 1, 0.22, 1) 0.4s";
          marker.style.transform = `rotate(${newRotation}deg)`;
          if (parent) parent.style.overflow = "visible";
        }
      }, 500);

      return () => clearTimeout(timeout);
    }, []);

    const handleVehicleIconClick = ({ vid }) => {
      setShowInfoBox(vid && vehicle.vid === vid);
    }

    useEffect(() => {
      if (vehicle && vehicle.vid) {
        global.EE.addEventListener(global.EE.EVENT_TYPES.MAP_ICON_CLICKED, handleVehicleIconClick);
      }

      return () => {
        global.EE.removeEventListener(global.EE.EVENT_TYPES.MAP_ICON_CLICKED, handleVehicleIconClick);
      }
    }, [ vehicle ]);

    if(!targetVehicle) return;
    var vehicleType = targetVehicle.typ || VEHICLE_TYPE_BIKE;
    const vehicleTypeName = VEHICLE_TYPES[vehicleType];
    const vehicleIcons = VEHICLE_ICON_URLS[vehicleTypeName] || VEHICLE_ICON_URLS["Two wheeler"];
    var iconUrl = vehicleIcons["NORMAL"];
    if (!targetVehicle.hwtyp || targetVehicle.hwtyp === DEVICE_HWTYPS["Wired"]) {
      if(vehicle.heartbeat && !vehicle.heartbeat.mainPower && !vehicle.heartbeat.externalVolt){
        iconUrl = vehicleIcons["POWER_OFF"];
      } else if (!vehicle.ignition && vehicle.motion) {
        iconUrl = vehicleIcons["MOTION"];
      } else if (vehicle.ignition && vehicle.motion) {
        iconUrl = vehicleIcons["IGNITION"];
      } else iconUrl = vehicleIcons["NORMAL"];
    } else {
      if (vehicle.ignition) iconUrl = vehicleIcons["IGNITION"];
      else iconUrl = vehicleIcons["NORMAL"];
    }

    if (isFridgeUser) {
      iconUrl = FridgeIconUrl;
    }

  const handleMarkerLoad = (marker, vehicleId) => {
    markerRefs.current[vehicleId] = marker
  }

  function getShortestRotation(currentAngle, newAngle) {
    const delta = ((newAngle - currentAngle + 540) % 360) - 180;
    return currentAngle + delta;
  }


  if(markerRefs.current[vehicle.vid] && !isFridgeUser){
    const parent = document.querySelector(`div[style*="z-index: ${vehicle.vid}"]`);
    const marker = document.querySelector(`div[style*="z-index: ${vehicle.vid}"] img`);
    if(marker){
      const currentRotation = parseFloat(marker.style.transform.replace(/rotate\((.*)deg\)/, '$1')) || 0;
      const newRotation = getShortestRotation(currentRotation, vehicle.direction);

      marker.style.transition = "cubic-bezier(0.19, 1, 0.22, 1) 0.4s";
      marker.style.transform = `rotate(${newRotation}deg)`;
      if (parent) parent.style.overflow = "visible";
    }
  }

  const handleMapMarkerClick = () => {
    setShowInfoBox(true);
    global.EE.emitEvent(global.EE.EVENT_TYPES.VEHICLE_INFO_SHOWN, vehicle);
    global.EE.emitEvent(global.EE.EVENT_TYPES.MAP_ICON_CLICKED, vehicle);
  }

  const handleInfoWindowClose = () => {
    setShowInfoBox(false);
    if (onInfoWindowClose) onInfoWindowClose(vehicle.vid);
    global.EE.emitEvent(global.EE.EVENT_TYPES.HIDE_VEHICLE_INFO, vehicle);
  }

  return (
    <>
      {vehicle.lat ?
        <Marker key={vehicle.vid} onClick={handleMapMarkerClick} clusterer={clusterer} noClustererRedraw={true}
        position={{ lat: vehicle.lat, lng: vehicle.lng }}
        icon={{ url: iconUrl, scaledSize: isFridgeUser ? new window.google.maps.Size(40, 40) : new window.google.maps.Size(37, 58), scale: 1, anchor: isFridgeUser ? { x: 20, y: 20 } : { x: 16, y: 16 }}}
        onLoad={(marker) => handleMarkerLoad(marker, vehicle.vid)}
        zIndex={vehicle.vid}
      >
        {(showInfoBox && vehicleInfo) ? <InfoWindow onCloseClick={handleInfoWindowClose} >
          <div className="info-box">
            <p className='veh-reg'>{ vehicleInfo.reg || "" }</p>
            <label>
              Last Seen:
              <p>{getLocalisedDate(vehicle.ts * 1000)}, {getLocalisedTime(vehicle.ts * 1000)}</p>
            </label>
            <label>
              Speed:
              <p>{vehicle.spd && vehicle.ignition ? vehicle.spd.toFixed(2) : 0} km/hr</p>
            </label>
            {vehicle.hasOwnProperty("ignition") ?
            <label>
              Ignition:
              <p>{vehicle.ignition ? "ON" : "OFF"}</p>
            </label> : null}
          </div>
        </InfoWindow> : null}
      </Marker>
       : null}
    </>
  );
}

export default CustomMarker
